import { createContext, useContext, useEffect, useState } from 'react';

const SearchFilterContext = createContext();

export const SearchFilterProvider = ({ children }) => {
  const initialFilterState = {
    searchValue: '',
    orderByValue: '',
    orderDirValue: 'desc',
    page: 1,
    pageSize: 10,
    filteredColumn: [],
    isFilter: false,
    filteredByField: {
      filterByField: '',
      filterBy: '',
    },
    visibleColumn: {},
  };
  const [filterState, setFilterState] = useState(() => {
    const saved = localStorage.getItem('filterState');
    return saved ? JSON.parse(saved) : initialFilterState;
  });
  const updateFilterState = (field, value) => {
    setFilterState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const resetFilterState = () => {
    setFilterState(initialFilterState);
    localStorage.removeItem('filterState');
  };

  useEffect(() => {
    localStorage.setItem('filterState', JSON.stringify(filterState));
  }, [filterState]);

  return (
    <SearchFilterContext.Provider
      value={{
        filterState,
        updateFilterState,
        resetFilterState,
      }}
    >
      {children}
    </SearchFilterContext.Provider>
  );
};

export const useSearchFilterContext = () => useContext(SearchFilterContext);
